import { api, formHeaders } from "@";

// Function to get the list of partners with pagination
export const getOurPartners = () => {
  return api.get("/api/AdminPartners?Page=1&PageSize=");
};

// Function to save a partner; updates if id exists, otherwise creates a new one
export const saveOurPartners = (form) => {
  if (form.id) {
    return api.put(`/api/AdminPartners/${form.id}`, form, formHeaders);
  }
  return api.post(`/api/AdminPartners`, form, formHeaders);
};
